export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_5-5ab2c57423cb7b7a4787bbd527b39ea8.png";